<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="competitionDropdown" role="button"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{ selectedCompetition ? selectedCompetition.id + ' - ' + selectedCompetition.name : 'Velg stevne' }}
          </a>
          <div class="dropdown-menu" aria-labelledby="competitionDropdown">
            <a class="dropdown-item" href="#" v-for="competition in activeCompetitions" :key="competition.id"
              @click="selectCompetition(competition.id)">
              {{ competition.id }} - {{ competition.name }}
            </a>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
// import CompetitionDataService from "../services/CompetitionDataService";
import MyComputed from '../myComputed';

export default {
  mixins: [MyComputed],
  data() {
    return {
      // selectedCompetition: undefined,
      // competitions: [
      //   { id: 1, name: 'Loading...' },
      //   // ...other competition options...
      // ],
    };
  },
  computed: {
    // selectedCompetition_computed() {
    //   // console.log("selectedCompetition_computed   (this.$store.state.auth.selectedCompetition): "+this.$store.state.auth.selectedCompetition);
    //   return this.$store.state.auth.selectedCompetition;
    // },
  },
  methods: {
    // getCallroomCompetitions() {
    //   CompetitionDataService.getAllCallroom()
    //     .then(response => { 
    //       this.competitions = response.data;
    //       // console.log("getAllCallroom");
    //       // console.log(response.data);
    //       // this.items.sort((a, b) => a.price - b.price);
    //       this.competitions = response.data.callroomcompetitions.sort((a,b) => b.id - a.id);
    //     })
    //     .catch(e => {
    //       console.log(e);
    //     });
    // },
    getCallroomCompetitions() {
      console.log("getCallroomCompetitions");
      console.log(this.activeCompetitions);
      this.$store.dispatch('competition/updateActiveCompetitions');
      // console.log("NOTICE: auth/updateCompetitions disabled");
      // this.competitions = this.$store.state.auth.competitions;
    },
    selectCompetition(competitionId) {
      console.log("selectedCompetition");
      console.log(this.selectedCompetition);
      // console.log(this.$store.commit('initialiseStore'));
      console.log(`HABLE: this.$router.push({ path: /competition/${competitionId}}`);
      this.$store.dispatch('competition/setSelectedCompetitionId', competitionId);
      this.$store.dispatch('participant/setSelectedParticipantId', undefined);
      this.$router.push({ path: `/competition/${competitionId}`});
      // this.$router.push({ path: `/competition/${competitionId}`}
      //   ).then((route) => {
      //     console.log(`HABLE: ${route.path} == ${this.$route.path}`);
      //     if (route.path === this.$route.path) {
      //       throw new Error('Navigation Duplicated TEST')
      //     }
      //   // do the actual then processing
      //   }).catch((error) => { console.error(error) });
     },
    competitionName(competitionId) {
      // console.log("competitionName");
      // const competition = this.competitions.find(comp => comp.id === competitionId);
      const competition = this.$store.state.competition.competitions && this.$store.state.competition.competitions.find(comp => comp.id === competitionId);
      console.log(competition);
      return competition ? competition.name : '';
    },
  },
  mounted() {
    console.log("mounted - SelectCompetition");
    console.log("mounted - SelectCompetition - competition_id: "+this.$route.params.competition_id);
    console.log("mounted - SelectCompetition - teamname: "+this.$route.params.teamname);
    console.log("mounted - SelectCompetition - route: ")
    console.log(this.$route);
    this.getCallroomCompetitions();
    console.log("mounted - SelectCompetition - competition_id: "+this.$route.params.competition_id);
    console.log("mounted - SelectCompetition - selectedCompetition:")
    console.log(this.selectedCompetition);    
    const competitionId = this.$route.params.competition_id || this.selectedCompetition && this.selectedCompetition.id;
    if (competitionId) {
      console.log("mounted - competitionId: "+competitionId);
      this.$store.dispatch('competition/setSelectedCompetitionId', competitionId);
    }
  },
  // watch: {
  //   '$route.params.competition_id'(newCompetitionId) {
  //     if (newCompetitionId && !this.selectedCompetition || newCompetitionId !== this.selectedCompetition.id) {
  //       console.log("watch - competition_id: "+newCompetitionId);
  //       console.log("watch - selectedCompetition:")
  //       console.log(this.selectedCompetition);
  //       this.$store.dispatch('competition/setSelectedCompetitionId', newCompetitionId);
  //     }
  //   }
  // }
};
</script>

<style scoped>
/* Add any custom styles for your navigation bar here */
</style>
